// PlanReadOnlyBanner — aviso de "tu plan venció, estás en modo consulta" (F1/F2, 13-ago-2026).
//
// Por qué existe: desde F2, un negocio de vertical con el plan vencido puede consultar todo pero
// no registrar nada nuevo. Sin este aviso, se enteraría al intentar guardar una cita — con el
// mensaje correcto, pero de golpe y sin contexto. Aquí se le dice antes, en cualquier pantalla.
//
// Solo aparece si el backend manda `planReadOnly: true`, que exige DOS condiciones (sin plan
// vigente Y con módulos de vertical). Los negocios GRATIS de lealtad nunca lo ven: ellos no
// pierden nada y decirles "tu plan venció" sería mentirles.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const PlanReadOnlyBanner: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  if (!currentUser?.planReadOnly) return null;

  return (
    <div
      role="status"
      className="mb-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 dark:border-amber-500/40 dark:bg-amber-500/10"
    >
      <div className="flex items-start gap-3">
        <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-amber-600 dark:text-amber-400" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-amber-900 dark:text-amber-200">
            Tu plan venció — estás en modo consulta
          </p>
          <p className="mt-0.5 text-sm text-amber-800 dark:text-amber-300/90">
            Puedes ver toda tu información y tus datos están intactos. Para volver a registrar
            citas y cobros, renueva tu plan.
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate('/dashboard/subscription')}
          className="shrink-0 rounded-md bg-amber-600 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-amber-700"
        >
          Ver mi plan
        </button>
      </div>
    </div>
  );
};

export default PlanReadOnlyBanner;
